<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>預算分配</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>預算分配</span></li>
          <li><span>已用預算</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <h2 class="panel-title">已用預算</h2>
            </header>
            <div class="panel-body">
              <div align="left">　
                類　　型：<span style="color:#0000CC;">聘僱/臨時 </span>
              </div>
              <div align="left">　
                單位名稱：<span style="color:#FF0000;">{{deptName}} </span>
              </div>
              <div align="left">　
                本薪總支出：<span style="color:#FF0000;">{{usedSalary | numberWithCommas}} </span>　
                勞保(實際)總支出：<span style="color:#FF0000;">{{usedLaborInsuranceImport | numberWithCommas}} </span>　
                勞退(實際)總支出：<span style="color:#FF0000;">{{usedLaborPensionImport | numberWithCommas}} </span>
              </div>
              <div align="left">　
                本薪剩餘預算：<span style="color:#FF0000;">{{remainingBudgetSalary | numberWithCommas}} </span>　
                勞保剩餘預算：<span style="color:#FF0000;">{{remainingBudgetLaborInsurance | numberWithCommas}} </span>　
                勞退剩餘預算：<span style="color:#FF0000;">{{remainingBudgetLaborPension | numberWithCommas}} </span>
              </div><br>
              <div class="s_tenr">
                <table class="table table-no-more table-bordered table-striped mb-none">
                  <thead>
                    <tr>
                      <th class="text-center" width="6%">學年度</th>
                      <th class="text-center" width="6%">年/月</th>
                      <th class="text-center" width="10%">本薪</th>
                      <th class="text-center" width="10%"><span style="color:#227700;">勞保費(實際)</span></th>
                      <th class="text-center" width="10%">勞保費(系統)</th>
                      <th class="text-center" width="10%"><span style="color:#227700;">勞退費(實際)</span></th>
                      <th class="text-center" width="10%">勞退費(系統)</th>
                      <th class="text-center" width="10%"><span style="color:#227700;">自付額(實際)</span></th>
                      <th class="text-center" width="10%">自付額(系統)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                      <td data-title="學年度" class="text-center">{{schYear}}</td>
                      <td data-title="年/月" class="text-center">{{item.yearMonth}}</td>
                      <td data-title="本薪" class="text-center">{{item.salary | numberWithCommas}}</td>
                      <td data-title="勞保費(實際)" class="text-center">{{item.laborInsuranceImport | numberWithCommas}}</td>
                      <td data-title="勞退費(系統)" class="text-center">{{item.laborInsurance | numberWithCommas}}</td>
                      <td data-title="勞退費(實際)" class="text-center">{{item.laborPensionImport | numberWithCommas}}</td>
                      <td data-title="勞退費(系統)" class="text-center">{{item.laborPension | numberWithCommas}}</td>
                      <td data-title="自付額(實際)" class="text-center">{{item.laborSelfImport | numberWithCommas}}</td>
                      <td data-title="自付額(系統)" class="text-center">{{item.laborSelf | numberWithCommas}}</td>
                    </tr>
                  </tbody>
                </table>
                <div align="center">
                  <br><a href="#" @click.prevent="routerBack" class="btn-upload btn btn-primary" style="background-color:#9e9e9e; border-color:#858484;">返回</a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      deptName: null,
      schYear: null,
      usedSalary: 0,
      usedLaborInsuranceImport: 0,
      usedLaborPensionImport: 0,
      remainingBudgetSalary: 0,
      remainingBudgetLaborInsurance: 0,
      remainingBudgetLaborPension: 0,
      list: []
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.$http.get("/api/budget/used-budget-work/" + this.id).then(a => {
      let item = a.body;
      this.deptName = item.deptName;
      this.schYear = item.schYear;
      this.usedSalary = item.usedSalary;
      this.usedLaborInsuranceImport = item.usedLaborInsuranceImport;
      this.usedLaborPensionImport = item.usedLaborPensionImport;
      this.remainingBudgetSalary = item.remainingBudgetSalary;
      this.remainingBudgetLaborInsurance = item.remainingBudgetLaborInsurance;
      this.remainingBudgetLaborPension = item.remainingBudgetLaborPension;
      this.list = item.usedBudgetList;
      this.list = this.list.filter(item => item.salary > 0 || item.laborInsuranceImport > 0 || item.laborPensionImport > 0 || item.laborSelfImport > 0 ||
        item.laborInsurance > 0 || item.laborPension > 0 || item.laborSelf > 0);
    });
  },
  methods: {
    routerBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
</style>
